angular.module("Main").controller("LoginDialogController", ["$uibModal", "$uibModalInstance",
    "AuthenticationService", "BookingService", "SessionService", "DialogService",
    function ($uibModal, $uibModalInstance, AuthenticationService, BookingService, SessionService, DialogService) {
        var vm = this;

        vm.dataForm = {};
        vm.loginData = {};
        vm.isMember = false;
        vm.openFormForgotPassword = false;
        vm.wrongLoginData = false;
        vm.openFormChangePassword = false;
        vm.verifyWithCode = false;
        vm.checkEmailAsFirst = true;
        vm.goToPassword = false;
        vm.isDuplicate = false;
        vm.passwordSecretNew = 'password';

        // reset login status
        SessionService.clear("globals");

        BookingService.loadLayoutConfiguration().then(function (data) {
            vm.layoutSettings = angular.fromJson(data.Layout);
            vm.registrierungZulassen = data.RegistrierungZulassen;
        });


        vm.passwordFieldToogle = function () {
            if (vm.passwordSecretNew === 'password') {
                vm.passwordSecretNew = 'text'
            } else {
                vm.passwordSecretNew = 'password';
            }
        };

        let checkLoginEmail = false;
        vm.checkEmailForLogin = function () {
            if (!checkLoginEmail) {
                checkLoginEmail = true;
                vm.dataLoading = true;
                vm.lockedEmail = false;
                vm.errorHeader = null;
                vm.miscError = false;
                BookingService.checkEmailForLogin(vm.loginData.email).then(function (data) {
                    vm.dataLoading = false;
                    vm.isDuplicate = false;

                    if (data.IsLocked) {
                        vm.dataLoading = false;
                        checkLoginEmail = false;
                        vm.lockedEmail = true;
                    } else if (data.uid && data.IsRegistered) {
                        vm.dataLoading = false;
                        vm.goToPassword = true;
                        checkLoginEmail = false;
                    } else if (!data.uid) {
                        vm.dataLoading = false;
                        vm.emailNotExists = true;
                        checkLoginEmail = false;
                    } else if (data.uid && !data.IsRegistered) {
                        let registration = {PersonNr: data.uid, email: vm.loginData.email};
                        vm.emailNotExists = false;
                        BookingService.createTemporaryMember(registration).then(function () {
                            vm.dataLoading = false;
                            vm.verifyWithCode = true;
                            checkLoginEmail = false;
                        }).catch(function () {
                            vm.dataLoading = false;
                            checkLoginEmail = false;
                            vm.miscError = true;
                            vm.errorHeader = "T_Fehler";
                            vm.errorText ="LT_Bei_senden_der_Verifizierungsemail_ist_ein_Fehler_aufgetreten";
                        });
                    }
                }).catch(function (error) {
                    checkLoginEmail = false;
                    vm.dataLoading = false;

                    if (error.status === 409) {
                        vm.isDuplicate = true;
                        vm.goToPassword = false;
                        vm.emailNotExists = false;
                        vm.errorHeader = "T_Fehler";
                        vm.errorText = "LT_Bitte_kontaktieren_Sie_Ihr_Studio";
                    } else {
                        vm.errorHeader = "T_Fehler";
                        vm.errorText = "LT_Bei_Überprüfung_der_Email_ist_ein Fehler_aufgetreten";
                    }
                })
            }
        };

        let checkCodeLogin = false;
        vm.checkCodeForLogin = function (code) {
            var data = {code: code, email: vm.loginData.email};
            if (!checkCodeLogin && vm.dataForm.code.$valid) {
                checkCodeLogin = true;
                vm.dataLoading = true;
                BookingService.checkRegisterCode(data).then(function (temporaryMember) {
                    if (temporaryMember.RightCode) {
                        vm.codeIsRight = true;
                        AuthenticationService.getNewPassword(temporaryMember.PersonNr).then(function () {
                            vm.newPasswordSend = true;
                            vm.goToPassword = true;
                            vm.infoText = "LT_Es_wurde_ein_neues_password_geschickt";
                            checkCodeLogin = false;
                            vm.dataLoading = false;
                        }).catch(function (err) {
                            vm.errorHeader = "T_Fehler";
                            //vm.errorText = "LT_Es_ist_ein_Fehler_aufgetreten";
                            vm.errorText ="LT_Bei_senden_der_Email_mit_Password_ist_ein_Fehler_aufgetreten";
                            checkCodeLogin = false;
                            vm.dataLoading = false;
                        });
                    } else {
                        vm.codeIsRight = false;
                        checkCodeLogin = false;
                        vm.dataLoading = false;
                    }
                })
            }
        };

        let login = false;
        vm.login = function (email, password) {
            vm.dataForm.password.$setTouched();
            if (!login) {
                login = true;
                vm.dataLoading = true;
                if (vm.dataForm.$valid) {
                    AuthenticationService.login(email, password).then(function (response) {
                        if (response != null) {
                            $uibModalInstance.close({
                                user: response
                            });
                            login = false;
                            vm.dataLoading = false;
                        } else {
                            vm.wrongLoginData = true;
                            vm.errorHeader = "T_Fehler";
                            vm.errorText = "LT_Falsche_Logindaten";
                            login = false;
                            vm.dataLoading = false;
                        }
                    }).catch(function (err) {
                        vm.errorHeader = "T_Fehler";
                        vm.errorText = "LT_Beim_der_Prüfung_der_Email_und_Kennwort_ist_ein_Fehler_aufgetreten";
                        login = false;
                        vm.dataLoading = false;
                    });
                }
            }
        };

        vm.openForgotPassword = function () {
            $uibModalInstance.close();
            $uibModal.open({
                templateUrl: "app/Main/views/dialogs/forgotPassword.html",
                controller: "ForgotPasswordController",
                controllerAs: "vm",
                windowClass: 'position-class',
                backdrop: "static"
            });
        };

        vm.openChangePassword = function () {
            $uibModalInstance.close();
            $uibModal.open({
                templateUrl: "app/Main/views/dialogs/changePassword.html",
                controller: "ChangePasswordController",
                controllerAs: "vm",
                windowClass: 'position-class',
                backdrop: "static"
            });
        };

        vm.registerModal = function () {
           // $uibModalInstance.close();
            DialogService.openRegisterDialog().then(function(response){
                if (response != null) {
                    $uibModalInstance.close({
                        user: response.user
                    });
                    login = false;
                    vm.dataLoading = false;
                } else {
                    vm.wrongLoginData = true;
                    vm.errorHeader = "T_Fehler";
                    vm.errorText = "LT_Falsche_Logindaten";
                    login = false;
                    vm.dataLoading = false;
                }
            }).catch(function () {

            })

        }
    }]);